export default __webpack_public_path__ + "static/media/505.d5724bd1.png";